var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dsf-exam-layout", {
    attrs: { "exam-loading": _vm.loading },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "space-between" } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          effect: "light",
                          content: _vm.practice.trainingName,
                          placement: "right",
                        },
                      },
                      [
                        _c("h3", { staticClass: "name" }, [
                          _vm._v(_vm._s(_vm.practice.trainingName)),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _c("el-col", { attrs: { span: 8 } }, [
                  _c("div", { staticClass: "user" }, [
                    _vm._v(_vm._s(_vm.practice.examUserName)),
                  ]),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "left",
        fn: function () {
          return [
            _c("p", { staticClass: "sub-title list bg pd-10" }, [
              _vm._v("答题卡"),
            ]),
            _c(
              "div",
              { staticClass: "card-list" },
              [
                _c(
                  "el-row",
                  { staticClass: "card-tips pd-10" },
                  [
                    _c("el-col", { staticClass: "a1", attrs: { span: 8 } }, [
                      _vm._v(" 正确：" + _vm._s(_vm.practice.rightNum) + " "),
                    ]),
                    _c(
                      "el-col",
                      { staticClass: "a2 error", attrs: { span: 8 } },
                      [
                        _vm._v(
                          " 错误：" + _vm._s(_vm.practice.unrightNum) + " "
                        ),
                      ]
                    ),
                    _c(
                      "el-col",
                      { staticClass: "a3 not-answer", attrs: { span: 8 } },
                      [
                        _vm._v(
                          " 未答：" +
                            _vm._s(
                              _vm.practice.questionsNum -
                                _vm.practice.rightNum -
                                _vm.practice.unrightNum
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("p", { staticClass: "sub-title list pd-10" }, [
                  _vm._v("共" + _vm._s(_vm.practice.questionsNum) + "题"),
                ]),
                _c(
                  "div",
                  { staticClass: "question-list" },
                  _vm._l(_vm.allStatus, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "item",
                        class: item,
                        on: {
                          click: function ($event) {
                            return _vm.go(index + 1)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(index + 1) + " ")]
                    )
                  }),
                  0
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "main",
        fn: function () {
          return [
            _vm.practice.questions
              ? [
                  _c("p", {
                    staticClass: "sub-title list bg pd-20",
                    domProps: {
                      innerHTML: _vm._s(_vm.practice.questions.items.text),
                    },
                  }),
                  _c("div", { staticClass: "exam-content" }, [
                    _c("div", { staticClass: "question" }, [
                      _c(
                        "div",
                        { staticClass: "left" },
                        [
                          _c("dsf-exam-item-box", {
                            attrs: {
                              "hide-mark": true,
                              type: "practice",
                              "read-only": _vm.previewStatus,
                              "show-consult": true,
                              subjects: _vm.practice.questions,
                              "exam-index": _vm.practice.questions.dsOrder - 1,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "right",
        fn: function () {
          return [
            _c("div", { staticClass: "item" }, [
              _c("p", { staticClass: "txt" }, [_vm._v("可练习时间")]),
              _c("p", { staticClass: "result" }, [
                _vm._v(_vm._s(_vm.practice.trainingDateTime)),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "item" },
              [
                _c("p", { staticClass: "txt" }, [_vm._v("当前进度")]),
                _c("el-progress", {
                  attrs: {
                    percentage: _vm.percentageNumber,
                    format: _vm.format,
                  },
                }),
              ],
              1
            ),
            _c("dsf-setting-font-size"),
            _vm.practice.questions && _vm.practice.questions.dsOrder > 1
              ? _c(
                  "div",
                  { staticClass: "exam-submit" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "exam-post before",
                        on: {
                          click: function ($event) {
                            return _vm.go()
                          },
                        },
                      },
                      [_vm._v(" 上一题 ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.practice.questions
              ? _c(
                  "div",
                  { staticClass: "exam-submit" },
                  [
                    !_vm.practice.questions.showStatus
                      ? _c(
                          "el-button",
                          {
                            staticClass: "exam-post",
                            on: { click: _vm.examPost },
                          },
                          [_vm._v("下一题")]
                        )
                      : _vm._e(),
                    _vm.practice.questions.showStatus
                      ? _c(
                          "el-button",
                          {
                            staticClass: "exam-post next1",
                            on: {
                              click: function ($event) {
                                return _vm.next()
                              },
                            },
                          },
                          [_vm._v("下一题")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }